module.exports = __webpack_public_path__ + "images/bankicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bankicon.png
// module id = rjHm
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13